var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _path, _circle3, _path2, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "27.83 23.06 442.17 451.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.67,244.81A260.4,260.4,0,0,0,396.24,117c-18.22-21.12-41.91-44.1-70.4-62.25C254,9,165,22,128,68S24,319,29,373s151,103,246,91,176-73,184-140C462.14,297.74,459.74,269.47,455.67,244.81Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.67,244.81A260.4,260.4,0,0,0,396.24,117c-18.22-21.12-41.91-44.1-70.4-62.25C254,9,165,22,128,68S24,319,29,373s151,103,246,91,176-73,184-140C462.14,297.74,459.74,269.47,455.67,244.81Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.34,119.57l6.61,1.5,1.55-6.83-6.16-1.41c0-.26,0-.52,0-.79a15,15,0,0,0-1.2-5.88l4.95-3.94-4.37-5.48L458,100.53a14.82,14.82,0,0,0-6.11-3.06V91.09h-7v6.38a15,15,0,0,0-5.87,2.86l-5.33-4.25-4.37,5.48,5.41,4.31a15,15,0,0,0-1.33,5.92l-7.16,1.63,1.56,6.83,7.13-1.62a15,15,0,0,0,3.51,4.61l-3.29,6.82,6.32,3,3.16-6.56a15,15,0,0,0,3.76.5,15.21,15.21,0,0,0,2.15-.17l3.18,6.6,6.31-3.05-3-6.16A15,15,0,0,0,461.34,119.57ZM437.74,112a10.65,10.65,0,1,1,10.64,10.64A10.64,10.64,0,0,1,437.74,112Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.34,164.86l6.61,1.51,1.55-6.83-6.16-1.41c0-.27,0-.53,0-.8a14.91,14.91,0,0,0-1.2-5.87l4.95-4L462.76,142l-4.76,3.8a15,15,0,0,0-6.11-3.07v-6.37h-7v6.37a14.92,14.92,0,0,0-5.87,2.87l-5.33-4.26-4.37,5.48,5.41,4.32a15,15,0,0,0-1.33,5.91l-7.16,1.64,1.56,6.83,7.13-1.63a15,15,0,0,0,3.51,4.61l-3.29,6.83,6.32,3,3.16-6.56a15,15,0,0,0,3.76.49,15.21,15.21,0,0,0,2.15-.17l3.18,6.6,6.31-3-3-6.16A15,15,0,0,0,461.34,164.86Zm-23.6-7.53A10.65,10.65,0,1,1,448.38,168,10.64,10.64,0,0,1,437.74,157.33Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.59,406.27l5.19,1.18,1.22-5.36-4.84-1.1c0-.21,0-.42,0-.63a11.82,11.82,0,0,0-.93-4.61l3.88-3.09-3.43-4.3-3.74,3a11.68,11.68,0,0,0-4.79-2.41v-5h-5.5v5a11.71,11.71,0,0,0-4.6,2.25l-4.19-3.34-3.43,4.3,4.24,3.38a11.62,11.62,0,0,0-1,4.65L264,401.45l1.23,5.36,5.59-1.28a11.82,11.82,0,0,0,2.76,3.62L271,414.5l4.95,2.39,2.48-5.15a11.24,11.24,0,0,0,4.64.26l2.49,5.18,5-2.39L288.23,410A11.6,11.6,0,0,0,291.59,406.27Zm-18.52-5.91a8.36,8.36,0,1,1,8.36,8.36A8.35,8.35,0,0,1,273.07,400.36Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,52,222,53.54l1.55-6.83-6.16-1.41c0-.27,0-.53,0-.8a14.91,14.91,0,0,0-1.2-5.87l4.95-4-4.37-5.48L212,33a15,15,0,0,0-6.11-3.07V23.56h-7v6.37A14.92,14.92,0,0,0,193,32.8l-5.33-4.26L183.31,34l5.41,4.32a15,15,0,0,0-1.33,5.91l-7.16,1.64,1.56,6.83,7.13-1.63a15,15,0,0,0,3.51,4.61l-3.29,6.82,6.32,3L198.62,59a15,15,0,0,0,3.76.49,15.21,15.21,0,0,0,2.15-.17l3.18,6.6,6.31-3-3-6.16A15,15,0,0,0,215.34,52Zm-23.6-7.53a10.65,10.65,0,1,1,10.64,10.65A10.64,10.64,0,0,1,191.74,44.5Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.55,169.93l5.59,1.27,1.32-5.78-5.22-1.2c0-.22,0-.44,0-.67a12.65,12.65,0,0,0-1-5l4.19-3.35-3.7-4.64-4,3.22a12.75,12.75,0,0,0-5.18-2.6v-5.4H82.6v5.4a12.58,12.58,0,0,0-5,2.43L73.12,150l-3.7,4.64L74,158.33a12.66,12.66,0,0,0-1.12,5l-6.07,1.38,1.32,5.79,6-1.38a12.79,12.79,0,0,0,3,3.91l-2.78,5.77,5.35,2.58,2.67-5.56a12.46,12.46,0,0,0,3.19.42,13.68,13.68,0,0,0,1.82-.14l2.69,5.59,5.35-2.58-2.51-5.22A12.89,12.89,0,0,0,96.55,169.93Zm-20-6.38a9,9,0,1,1,9,9A9,9,0,0,1,76.56,163.55Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.43,145.49l7.74,1.77,1.82-8-7.22-1.65c0-.31,0-.61,0-.93a17.46,17.46,0,0,0-1.4-6.87l5.8-4.63-5.12-6.41-5.58,4.45a17.59,17.59,0,0,0-7.15-3.6v-7.46H50.16v7.46A17.55,17.55,0,0,0,43.3,123l-6.25-5-5.11,6.42,6.33,5a17.43,17.43,0,0,0-1.55,6.93l-8.39,1.91,1.83,8,8.35-1.9a17.49,17.49,0,0,0,4.1,5.39l-3.85,8,7.4,3.56,3.7-7.68a17.29,17.29,0,0,0,4.4.58,17.48,17.48,0,0,0,2.52-.2l3.72,7.73,7.39-3.56L64.42,151A17.47,17.47,0,0,0,69.43,145.49ZM41.8,136.68a12.46,12.46,0,1,1,12.46,12.46A12.46,12.46,0,0,1,41.8,136.68Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.57 335.35 182.71 341.93 189.63 341.93 184.03 346 186.17 352.58 180.57 348.51 174.97 352.58 177.11 346 171.51 341.93 178.43 341.93 180.57 335.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.94 335.35 205.08 341.93 212 341.93 206.41 346 208.54 352.58 202.94 348.51 197.35 352.58 199.49 346 193.89 341.93 200.81 341.93 202.94 335.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.32 335.35 227.46 341.93 234.38 341.93 228.78 346 230.92 352.58 225.32 348.51 219.72 352.58 221.86 346 216.26 341.93 223.18 341.93 225.32 335.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.69 335.35 249.83 341.93 256.75 341.93 251.15 346 253.29 352.58 247.69 348.51 242.09 352.58 244.23 346 238.63 341.93 245.55 341.93 247.69 335.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.06 335.35 272.2 341.93 279.12 341.93 273.52 346 275.66 352.58 270.06 348.51 264.46 352.58 266.6 346 261 341.93 267.92 341.93 270.06 335.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 329,
    width: 121,
    height: 32,
    rx: 7.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.2 228.81 40.55 232.96 44.91 232.96 41.38 235.52 42.73 239.67 39.2 237.1 35.67 239.67 37.02 235.52 33.49 232.96 37.86 232.96 39.2 228.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.3 228.81 54.65 232.96 59.01 232.96 55.48 235.52 56.83 239.67 53.3 237.1 49.77 239.67 51.12 235.52 47.59 232.96 51.95 232.96 53.3 228.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.39 228.81 68.74 232.96 73.1 232.96 69.58 235.52 70.92 239.67 67.39 237.1 63.87 239.67 65.22 235.52 61.69 232.96 66.05 232.96 67.39 228.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.49 228.81 82.84 232.96 87.2 232.96 83.67 235.52 85.02 239.67 81.49 237.1 77.96 239.67 79.31 235.52 75.78 232.96 80.14 232.96 81.49 228.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.59 228.81 96.94 232.96 101.3 232.96 97.77 235.52 99.11 239.67 95.59 237.1 92.06 239.67 93.41 235.52 89.88 232.96 94.24 232.96 95.59 228.81",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.76,
    y: 224.81,
    width: 76.24,
    height: 20.16,
    rx: 7.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.53,347.24s1-3.49,1-3.72c.37-2.65-.48-8-3.17-9.28a3.54,3.54,0,0,0-4.82,2.13c-.72,2,.19,4.42,1.28,6.1C100.08,344.44,104.53,347.24,104.53,347.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,346.08c2.14.94,7.4.82,7.4.82s-1.13-3.44-1.23-3.64c-1.15-2.41-4.79-6.4-7.76-6A3.54,3.54,0,0,0,47,341.7C47.46,343.76,49.57,345.28,51.4,346.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.21,361.3c2.23.33,6.92-1,7.29-1.14A63,63,0,0,0,63.34,368c.65,1.5,1.34,3,2.06,4.46-.43-.63-.81-1.18-.88-1.26-1.75-2-6.31-4.89-9.07-3.72a3.55,3.55,0,0,0-1.57,5c1,1.85,3.46,2.76,5.43,3.05s6-.78,7.09-1.08c.28.56.55,1.13.83,1.69,1.36,2.7,2.73,5.39,4,8.08.44.94.85,1.89,1.25,2.83-.38-.55-.7-1-.76-1.08-1.75-2-6.32-4.9-9.07-3.73a3.53,3.53,0,0,0-1.57,5c1,1.85,3.45,2.77,5.43,3.05s5.63-.68,6.89-1c.39,1,.78,2,1.11,2.93.21.67.46,1.29.64,2s.37,1.34.55,2c.31,1.27.63,2.59.9,3.85.19.87.36,1.7.53,2.54-.43-.94-1.31-2.78-1.4-2.92-1.43-2.26-5.5-5.8-8.4-5.06A3.55,3.55,0,0,0,65,399.39c.73,2,3,3.25,4.91,3.84,2.1.64,6.75,0,7.33,0,.28,1.39.54,2.74.76,4,.79,4.45,1.27,8.18,1.57,10.79.05.46.1.88.14,1.27h-9l2,38.71h18l2-38.71H84.24l.19-.39c1.15-2.39,2.74-5.84,4.47-10.06.55-1.33,1.11-2.76,1.67-4.24.56.11,5.16,1,7.31.57,2-.44,4.31-1.55,5.18-3.47a3.55,3.55,0,0,0-2-4.9c-2.83-.95-7.16,2.27-8.75,4.42-.09.13-1,1.62-1.48,2.57.22-.61.45-1.19.67-1.82.45-1.23.87-2.47,1.32-3.81.2-.66.4-1.32.59-2s.36-1.38.54-2.08c.38-1.62.7-3.28,1-5,1.08.4,5,1.74,7,1.6s4.49-.87,5.64-2.64a3.55,3.55,0,0,0-1.19-5.14c-2.66-1.37-7.43,1.16-9.32,3.05-.12.11-1.33,1.62-2,2.46.16-1,.33-2,.45-3.05.37-3,.65-6,.94-9,.09-.92.19-1.84.29-2.75.38.14,4.94,1.84,7.18,1.68,2-.14,4.49-.87,5.64-2.64a3.54,3.54,0,0,0-1.19-5.14c-2.66-1.37-7.43,1.16-9.32,3-.14.15-1.88,2.32-2.29,2.89.21-2,.44-4,.75-6a61,61,0,0,1,1.73-7.9c.18.06,4.92,1.85,7.22,1.69,2-.14,4.49-.87,5.64-2.64a3.54,3.54,0,0,0-1.19-5.13c-2.66-1.38-7.43,1.15-9.32,3-.13.12-1.45,1.77-2.06,2.57l-.15-.08a46.59,46.59,0,0,1,3.13-7.5c.69-1.33,1.41-2.57,2.14-3.75.85.42,4.76,2.32,6.84,2.4s4.56-.37,5.9-2a3.54,3.54,0,0,0-.62-5.23c-2.5-1.66-7.51.33-9.6,2-.12.09-1.17,1.14-1.93,1.91.34-.53.68-1.08,1-1.58,1.25-1.89,2.51-3.54,3.64-5,.65-.82,1.25-1.55,1.83-2.22,1,0,5.28-.15,7.13-1s3.88-2.43,4.31-4.5a3.54,3.54,0,0,0-3-4.36c-3-.32-6.51,3.76-7.6,6.2-.09.21-1.18,3.68-1.13,3.68h.07c-.57.64-1.16,1.33-1.8,2.1-1.16,1.43-2.46,3.06-3.76,4.92a61.29,61.29,0,0,0-3.9,6.22,46.25,46.25,0,0,0-3.34,7.5l0,.1c0-.88,0-3.33,0-3.52-.35-2.65-2.57-7.57-5.51-8.11a3.55,3.55,0,0,0-4.09,3.33c-.17,2.11,1.36,4.21,2.85,5.54,1.68,1.5,6.34,2.95,6.71,3.07a63.48,63.48,0,0,0-2,8.13c-.29,1.6-.53,3.22-.74,4.85,0-.76,0-1.44,0-1.53-.35-2.65-2.57-7.57-5.51-8.11a3.54,3.54,0,0,0-4.09,3.33c-.17,2.1,1.36,4.21,2.85,5.54s5.46,2.67,6.51,3c-.08.63-.17,1.25-.24,1.88-.36,3-.7,6-1.13,8.93-.15,1-.34,2.05-.52,3.06,0-.67,0-1.24,0-1.33-.34-2.65-2.56-7.57-5.51-8.11a3.54,3.54,0,0,0-4.08,3.33c-.17,2.11,1.35,4.21,2.84,5.54s5.08,2.54,6.32,2.94c-.22,1-.43,2.07-.69,3.06-.19.67-.33,1.33-.56,2s-.43,1.31-.64,2c-.45,1.24-.9,2.52-1.37,3.71-.32.83-.64,1.62-1,2.42.16-1,.44-3.05.44-3.22a13.82,13.82,0,0,0-1.84-6.69,5.11,5.11,0,0,0,0-.78,3.54,3.54,0,0,0-4.33-3c-2.9.77-4.73,5.84-4.87,8.51,0,.16.1,1.88.18,3-.15-.63-.28-1.24-.44-1.89-.3-1.28-.64-2.54-1-3.91q-.3-1-.6-2c-.19-.66-.47-1.34-.7-2-.57-1.57-1.23-3.12-1.92-4.68,1.12-.26,5.08-1.27,6.67-2.5s3.26-3.2,3.25-5.31A3.55,3.55,0,0,0,80,375.69c-3,.33-5.56,5.07-6.1,7.68,0,.17-.21,2.09-.28,3.15-.43-.94-.85-1.87-1.31-2.79-1.33-2.68-2.76-5.35-4.17-8-.43-.82-.86-1.64-1.28-2.46.4-.09,5.13-1.19,6.91-2.55,1.59-1.22,3.27-3.21,3.25-5.32a3.54,3.54,0,0,0-3.82-3.63c-3,.33-5.56,5.07-6.1,7.68,0,.2-.29,3-.32,3.67-.94-1.8-1.86-3.61-2.69-5.43a61.93,61.93,0,0,1-2.92-7.54c.19,0,5.13-1.17,7-2.57,1.58-1.21,3.26-3.2,3.25-5.31a3.55,3.55,0,0,0-3.83-3.63c-3,.33-5.56,5.07-6.09,7.68,0,.17-.23,2.28-.3,3.29H61a45.39,45.39,0,0,1-1.52-8c-.17-1.48-.25-2.91-.29-4.31.94-.11,5.25-.69,7-1.76s3.59-2.83,3.81-4.93a3.55,3.55,0,0,0-3.4-4c-3,0-6.08,4.43-6.91,7,0,.14-.34,1.59-.55,2.66,0-.63,0-1.28,0-1.88,0-2.27.14-4.34.28-6.17.09-1.05.19-2,.3-2.87.86-.59,4.33-3,5.39-4.78s1.89-4.17,1.11-6.13a3.53,3.53,0,0,0-4.87-2c-2.66,1.37-3.36,6.72-2.92,9.36,0,.23,1,3.72,1.09,3.69l.05,0c-.12.85-.23,1.75-.34,2.75-.18,1.83-.37,3.91-.42,6.18a63.63,63.63,0,0,0,.17,7.34,46.46,46.46,0,0,0,1.36,8.1l0,.09c-.47-.74-1.86-2.76-2-2.91-1.75-2-6.31-4.9-9.07-3.73a3.55,3.55,0,0,0-1.57,5C48.8,360.1,51.24,361,53.21,361.3Zm29.68,39.22c1.53,1.66,5.45,3.6,6,3.85-.53,1.32-1.06,2.59-1.59,3.78-1.79,4.14-3.45,7.52-4.64,9.86L82,419.29h-.2c-.06-.46-.13-1-.2-1.52-.37-2.64-.94-6.39-1.83-10.86-.27-1.42-.6-2.92-.95-4.46A37.67,37.67,0,0,0,82.89,400.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,346.08c2.14.94,7.4.82,7.4.82s-1.13-3.44-1.23-3.64c-1.15-2.41-4.79-6.4-7.76-6A3.54,3.54,0,0,0,47,341.7C47.46,343.76,49.57,345.28,51.4,346.08Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,347.24s1-3.49,1-3.72c.37-2.65-.48-8-3.17-9.28a3.54,3.54,0,0,0-4.82,2.13c-.72,2,.19,4.42,1.28,6.1C100.08,344.44,104.53,347.24,104.53,347.24Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.21,361.3c2.23.33,6.92-1,7.29-1.14A63,63,0,0,0,63.34,368c.65,1.5,1.34,3,2.06,4.46-.43-.63-.81-1.18-.88-1.26-1.75-2-6.31-4.89-9.07-3.72a3.55,3.55,0,0,0-1.57,5c1,1.85,3.46,2.76,5.43,3.05s6-.78,7.09-1.08c.28.56.55,1.13.83,1.69,1.36,2.7,2.73,5.39,4,8.08.44.94.85,1.89,1.25,2.83-.38-.55-.7-1-.76-1.08-1.75-2-6.32-4.9-9.07-3.73a3.53,3.53,0,0,0-1.57,5c1,1.85,3.45,2.77,5.43,3.05s5.63-.68,6.89-1c.39,1,.78,2,1.11,2.93.21.67.46,1.29.64,2s.37,1.34.55,2c.31,1.27.63,2.59.9,3.85.19.87.36,1.7.53,2.54-.43-.94-1.31-2.78-1.4-2.92-1.43-2.26-5.5-5.8-8.4-5.06A3.55,3.55,0,0,0,65,399.39c.73,2,3,3.25,4.91,3.84,2.1.64,6.75,0,7.33,0,.28,1.39.54,2.74.76,4,.79,4.45,1.27,8.18,1.57,10.79.05.46.1.88.14,1.27h-9l2,38.71h18l2-38.71H84.24l.19-.39c1.15-2.39,2.74-5.84,4.47-10.06.55-1.33,1.11-2.76,1.67-4.24.56.11,5.16,1,7.31.57,2-.44,4.31-1.55,5.18-3.47a3.55,3.55,0,0,0-2-4.9c-2.83-.95-7.16,2.27-8.75,4.42-.09.13-1,1.62-1.48,2.57.22-.61.45-1.19.67-1.82.45-1.23.87-2.47,1.32-3.81.2-.66.4-1.32.59-2s.36-1.38.54-2.08c.38-1.62.7-3.28,1-5,1.08.4,5,1.74,7,1.6s4.49-.87,5.64-2.64a3.55,3.55,0,0,0-1.19-5.14c-2.66-1.37-7.43,1.16-9.32,3.05-.12.11-1.33,1.62-2,2.46.16-1,.33-2,.45-3.05.37-3,.65-6,.94-9,.09-.92.19-1.84.29-2.75.38.14,4.94,1.84,7.18,1.68,2-.14,4.49-.87,5.64-2.64a3.54,3.54,0,0,0-1.19-5.14c-2.66-1.37-7.43,1.16-9.32,3-.14.15-1.88,2.32-2.29,2.89.21-2,.44-4,.75-6a61,61,0,0,1,1.73-7.9c.18.06,4.92,1.85,7.22,1.69,2-.14,4.49-.87,5.64-2.64a3.54,3.54,0,0,0-1.19-5.13c-2.66-1.38-7.43,1.15-9.32,3-.13.12-1.45,1.77-2.06,2.57l-.15-.08a46.59,46.59,0,0,1,3.13-7.5c.69-1.33,1.41-2.57,2.14-3.75.85.42,4.76,2.32,6.84,2.4s4.56-.37,5.9-2a3.54,3.54,0,0,0-.62-5.23c-2.5-1.66-7.51.33-9.6,2-.12.09-1.17,1.14-1.93,1.91.34-.53.68-1.08,1-1.58,1.25-1.89,2.51-3.54,3.64-5,.65-.82,1.25-1.55,1.83-2.22,1,0,5.28-.15,7.13-1s3.88-2.43,4.31-4.5a3.54,3.54,0,0,0-3-4.36c-3-.32-6.51,3.76-7.6,6.2-.09.21-1.18,3.68-1.13,3.68h.07c-.57.64-1.16,1.33-1.8,2.1-1.16,1.43-2.46,3.06-3.76,4.92a61.29,61.29,0,0,0-3.9,6.22,46.25,46.25,0,0,0-3.34,7.5l0,.1c0-.88,0-3.33,0-3.52-.35-2.65-2.57-7.57-5.51-8.11a3.55,3.55,0,0,0-4.09,3.33c-.17,2.11,1.36,4.21,2.85,5.54,1.68,1.5,6.34,2.95,6.71,3.07a63.48,63.48,0,0,0-2,8.13c-.29,1.6-.53,3.22-.74,4.85,0-.76,0-1.44,0-1.53-.35-2.65-2.57-7.57-5.51-8.11a3.54,3.54,0,0,0-4.09,3.33c-.17,2.1,1.36,4.21,2.85,5.54s5.46,2.67,6.51,3c-.08.63-.17,1.25-.24,1.88-.36,3-.7,6-1.13,8.93-.15,1-.34,2.05-.52,3.06,0-.67,0-1.24,0-1.33-.34-2.65-2.56-7.57-5.51-8.11a3.54,3.54,0,0,0-4.08,3.33c-.17,2.11,1.35,4.21,2.84,5.54s5.08,2.54,6.32,2.94c-.22,1-.43,2.07-.69,3.06-.19.67-.33,1.33-.56,2s-.43,1.31-.64,2c-.45,1.24-.9,2.52-1.37,3.71-.32.83-.64,1.62-1,2.42.16-1,.44-3.05.44-3.22a13.82,13.82,0,0,0-1.84-6.69,5.11,5.11,0,0,0,0-.78,3.54,3.54,0,0,0-4.33-3c-2.9.77-4.73,5.84-4.87,8.51,0,.16.1,1.88.18,3-.15-.63-.28-1.24-.44-1.89-.3-1.28-.64-2.54-1-3.91q-.3-1-.6-2c-.19-.66-.47-1.34-.7-2-.57-1.57-1.23-3.12-1.92-4.68,1.12-.26,5.08-1.27,6.67-2.5s3.26-3.2,3.25-5.31A3.55,3.55,0,0,0,80,375.69c-3,.33-5.56,5.07-6.1,7.68,0,.17-.21,2.09-.28,3.15-.43-.94-.85-1.87-1.31-2.79-1.33-2.68-2.76-5.35-4.17-8-.43-.82-.86-1.64-1.28-2.46.4-.09,5.13-1.19,6.91-2.55,1.59-1.22,3.27-3.21,3.25-5.32a3.54,3.54,0,0,0-3.82-3.63c-3,.33-5.56,5.07-6.1,7.68,0,.2-.29,3-.32,3.67-.94-1.8-1.86-3.61-2.69-5.43a61.93,61.93,0,0,1-2.92-7.54c.19,0,5.13-1.17,7-2.57,1.58-1.21,3.26-3.2,3.25-5.31a3.55,3.55,0,0,0-3.83-3.63c-3,.33-5.56,5.07-6.09,7.68,0,.17-.23,2.28-.3,3.29H61a45.39,45.39,0,0,1-1.52-8c-.17-1.48-.25-2.91-.29-4.31.94-.11,5.25-.69,7-1.76s3.59-2.83,3.81-4.93a3.55,3.55,0,0,0-3.4-4c-3,0-6.08,4.43-6.91,7,0,.14-.34,1.59-.55,2.66,0-.63,0-1.28,0-1.88,0-2.27.14-4.34.28-6.17.09-1.05.19-2,.3-2.87.86-.59,4.33-3,5.39-4.78s1.89-4.17,1.11-6.13a3.53,3.53,0,0,0-4.87-2c-2.66,1.37-3.36,6.72-2.92,9.36,0,.23,1,3.72,1.09,3.69l.05,0c-.12.85-.23,1.75-.34,2.75-.18,1.83-.37,3.91-.42,6.18a63.63,63.63,0,0,0,.17,7.34,46.46,46.46,0,0,0,1.36,8.1l0,.09c-.47-.74-1.86-2.76-2-2.91-1.75-2-6.31-4.9-9.07-3.73a3.55,3.55,0,0,0-1.57,5C48.8,360.1,51.24,361,53.21,361.3Zm29.68,39.22c1.53,1.66,5.45,3.6,6,3.85-.53,1.32-1.06,2.59-1.59,3.78-1.79,4.14-3.45,7.52-4.64,9.86L82,419.29h-.2c-.06-.46-.13-1-.2-1.52-.37-2.64-.94-6.39-1.83-10.86-.27-1.42-.6-2.92-.95-4.46A37.67,37.67,0,0,0,82.89,400.52Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 56,
    width: 349,
    height: 258,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.65,
    y: 46,
    width: 352.75,
    height: 259.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.65,
    y: 46,
    width: 58.12,
    height: 259.17,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.65,
    y: 46,
    width: 352.75,
    height: 21.28,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,96.38a5.86,5.86,0,1,0-5.86,5.86A5.86,5.86,0,0,0,96.94,96.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.82,
    y1: 96.87,
    x2: 130.62,
    y2: 96.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,123.23a5.86,5.86,0,1,0-5.86,5.85A5.86,5.86,0,0,0,96.94,123.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.82,
    y1: 123.71,
    x2: 130.62,
    y2: 123.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,150.07a5.86,5.86,0,1,0-5.86,5.86A5.86,5.86,0,0,0,96.94,150.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.82,
    y1: 150.56,
    x2: 130.62,
    y2: 150.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,176.92a5.86,5.86,0,1,0-5.86,5.86A5.87,5.87,0,0,0,96.94,176.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.82,
    y1: 177.41,
    x2: 130.62,
    y2: 177.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.94,203.77a5.86,5.86,0,1,0-5.86,5.86A5.86,5.86,0,0,0,96.94,203.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.82,
    y1: 204.26,
    x2: 130.62,
    y2: 204.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 222.92,
    width: 230.91,
    height: 8.28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 237.53,
    width: 230.91,
    height: 8.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 252.15,
    width: 230.91,
    height: 8.28
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 266.76,
    width: 230.91,
    height: 8.28
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 242.18,
    y: 244.17,
    width: 13.24,
    height: 38.67,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.47,
    y: 228.21,
    width: 13.24,
    height: 54.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.76,
    y: 247.85,
    width: 13.24,
    height: 34.99,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.05,
    y: 268.72,
    width: 13.24,
    height: 14.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.34,
    y: 241.1,
    width: 13.24,
    height: 41.74,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.63,
    y: 249.69,
    width: 13.24,
    height: 33.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.92,
    y: 270.56,
    width: 13.24,
    height: 12.28,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.04,
    y: 244.17,
    width: 13.24,
    height: 38.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.75,
    y: 228.21,
    width: 13.24,
    height: 54.63,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.47,
    y: 247.85,
    width: 13.24,
    height: 34.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.18,
    y: 268.72,
    width: 13.24,
    height: 14.12,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.89,
    y: 241.1,
    width: 13.24,
    height: 41.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.6,
    y: 249.69,
    width: 13.24,
    height: 33.15,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.31,
    y: 270.56,
    width: 13.24,
    height: 12.28,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 241.81,
    x2: 131.36,
    y2: 241.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 249.52,
    x2: 131.36,
    y2: 249.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 257.23,
    x2: 131.36,
    y2: 257.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 264.94,
    x2: 131.36,
    y2: 264.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 272.64,
    x2: 131.36,
    y2: 272.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.41,
    y1: 280.35,
    x2: 131.36,
    y2: 280.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.21,
    y1: 52.79,
    x2: 115.06,
    y2: 52.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.21,
    y1: 57.91,
    x2: 115.06,
    y2: 57.91,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.21,
    y1: 63.03,
    x2: 115.06,
    y2: 63.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.38,
    y: 166.92,
    width: 110.13,
    height: 44.59,
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.5 203.81 377.5 211.52 267.38 211.52 267.38 186.74 284.99 181.79 309.77 181.79 319.69 194.45 337.3 194.45 351.07 203.81 377.5 203.81",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.46,
    y1: 175.18,
    x2: 370.9,
    y2: 175.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3,192.56v2.26h-1.21v-2.26h-3.62v-1.14l3.47-7.81h1.36v7.81h.9v1.14Zm-3.68-1.14h2.47V186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.41,188.17a1.81,1.81,0,0,1,1.66-.93c1.45,0,2.09,1.06,2.09,2.66v2.2c0,1.71-.82,2.83-2.53,2.83s-2.52-1.12-2.52-2.83v-.76h1.17v.84c0,1,.42,1.61,1.31,1.61s1.32-.6,1.32-1.61V190c0-1-.42-1.62-1.32-1.62a1.21,1.21,0,0,0-1.26,1.2v.26h-1.17l.31-6.23h4.41v1.12h-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.49,185.36v3.53c0,1.09-.51,1.81-1.6,1.81s-1.6-.72-1.6-1.81v-3.53c0-1.08.51-1.81,1.6-1.81S362.49,184.28,362.49,185.36Zm-2.4-.05V189c0,.61.23,1,.8,1s.8-.4.8-1v-3.65c0-.61-.24-1-.8-1S360.09,184.7,360.09,185.31Zm6.1-1.7-4.42,11.21H361l4.42-11.21Zm1.81,5.92v3.53c0,1.09-.49,1.81-1.6,1.81s-1.6-.72-1.6-1.81v-3.53c0-1.07.51-1.79,1.6-1.79S368,188.46,368,189.53Zm-2.4,0v3.63c0,.61.24,1,.8,1s.8-.42.8-1v-3.63c0-.61-.24-1-.8-1S365.6,188.88,365.6,189.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.75,87.35V80h-1.5v-.83h3.91V80h-1.51v7.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,79.17c1.29,0,1.83.66,1.83,1.87v.67a1.52,1.52,0,0,1-1,1.68c.75.22,1,.83,1,1.71v1.27a2.07,2.07,0,0,0,.16,1h-.92a2.06,2.06,0,0,1-.15-1V85.07c0-.92-.43-1.21-1.19-1.21h-.65v3.49h-.91V79.17ZM151.37,83c.73,0,1.16-.23,1.16-1.12v-.79c0-.73-.27-1.12-.95-1.12h-.89v3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.3,82.8v.81h-2v2.91h2.45v.83h-3.36V79.17h3.36V80H155.3v2.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,87.35h-.81V79.17h1.15l1.9,5.92V79.17h.8v8.18h-.95l-2.09-6.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,79.17c1.27,0,1.85.77,1.85,2v4.12c0,1.25-.58,2-1.85,2h-1.92V79.17Zm0,7.35c.66,0,1-.41,1-1.15V81.16c0-.75-.31-1.16-1-1.16h-1v6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 145.15,
    y1: 147.97,
    x2: 145.15,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 134.65,
    x2: 423.49,
    y2: 134.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 143.77,
    x2: 423.49,
    y2: 143.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 126.02,
    x2: 423.49,
    y2: 126.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 117.4,
    x2: 423.49,
    y2: 117.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 108.77,
    x2: 423.49,
    y2: 108.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 100.14,
    x2: 423.49,
    y2: 100.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.17,
    y1: 91.51,
    x2: 423.49,
    y2: 91.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.16,
    y1: 147.97,
    x2: 168.16,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.17,
    y1: 147.97,
    x2: 191.17,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.18,
    y1: 147.97,
    x2: 214.18,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.19,
    y1: 147.97,
    x2: 237.19,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.2,
    y1: 147.97,
    x2: 260.2,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.21,
    y1: 147.97,
    x2: 283.21,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.22,
    y1: 147.97,
    x2: 306.22,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.23,
    y1: 147.97,
    x2: 329.23,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.24,
    y1: 147.97,
    x2: 352.24,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.25,
    y1: 147.97,
    x2: 375.25,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 398.26,
    y1: 147.97,
    x2: 398.26,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.27,
    y1: 147.97,
    x2: 421.27,
    y2: 144.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "419.86 142.34 419.86 93.17 419.98 88.76 405.25 91.76 386.76 97.67 364.32 100.14 340.9 107.04 318.71 104.33 293.57 97.18 269.41 108.24 250.42 101.12 225.03 104.33 203.83 95.45 179.42 129.72 156.5 102.36 145.1 113.63 145.1 142.34 419.86 142.34",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.86 142.34 419.86 93.17 419.98 88.76 405.25 91.76 386.76 97.67 364.32 100.14 340.9 107.04 318.71 104.33 293.57 97.18 269.41 108.24 250.42 101.12 225.03 104.33 203.83 95.45 179.42 129.72 156.5 102.36 145.1 113.63 145.1 142.34 419.86 142.34",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.05 142.34 420.05 125.81 420.11 123.78 405.25 117.77 386.76 113.58 364.32 116.05 340.9 120.24 318.71 117.03 293.57 114.57 269.41 115.06 250.42 120.49 225.03 124.92 203.83 120.49 179.42 122.7 156.5 125.17 145.4 126.65 144.88 126.65 144.88 142.34 420.05 142.34",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.49,
    cy: 125.17,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,122.7a1.48,1.48,0,1,0-1.48,1.48A1.47,1.47,0,0,0,180.9,122.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.83,
    cy: 120.49,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.03,
    cy: 124.92,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.42,
    cy: 120.49,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.41,
    cy: 115.06,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.57,
    cy: 114.57,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.19,117a1.48,1.48,0,1,0-1.48,1.48A1.47,1.47,0,0,0,320.19,117Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.9,
    cy: 120.24,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364.32,
    cy: 116.05,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.76,
    cy: 113.58,
    r: 1.48,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,117.77a1.48,1.48,0,1,0-1.48,1.48A1.47,1.47,0,0,0,406.73,117.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.49,
    cy: 102.36,
    r: 1.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.42,
    cy: 129.72,
    r: 1.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.31,95.45a1.48,1.48,0,1,0-1.48,1.48A1.48,1.48,0,0,0,205.31,95.45Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.03,
    cy: 104.33,
    r: 1.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.9,101.12a1.48,1.48,0,1,0-1.48,1.48A1.47,1.47,0,0,0,251.9,101.12Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.41,
    cy: 107.66,
    r: 1.48
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.57,
    cy: 97.18,
    r: 1.48
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.71,
    cy: 104.33,
    r: 1.48
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.9,
    cy: 107.04,
    r: 1.48
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.32,
    cy: 100.14,
    r: 1.48
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.76,
    cy: 97.67,
    r: 1.48
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 405.25,
    cy: 91.76,
    r: 1.48
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402,85.18v2.26h-1.21V85.18h-3.62V84.05l3.47-7.82H402v7.82h.9v1.13Zm-3.68-1.13h2.47V78.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,80.8a1.79,1.79,0,0,1,1.66-.93c1.45,0,2.09,1,2.09,2.66v2.19c0,1.71-.82,2.83-2.53,2.83s-2.52-1.12-2.52-2.83V84h1.17v.83c0,1,.42,1.62,1.31,1.62s1.32-.61,1.32-1.62V82.62c0-1-.42-1.62-1.32-1.62A1.21,1.21,0,0,0,405,82.2v.26h-1.17l.3-6.23h4.42v1.12h-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.15,78v3.54c0,1.09-.51,1.81-1.6,1.81s-1.6-.72-1.6-1.81V78c0-1.07.51-1.81,1.6-1.81S413.15,76.91,413.15,78Zm-2.4,0v3.65c0,.61.23,1,.8,1s.8-.4.8-1V77.93c0-.61-.24-1-.8-1S410.75,77.32,410.75,77.93Zm6.1-1.7-4.42,11.21h-.75l4.42-11.21Zm1.81,5.93v3.52c0,1.09-.49,1.81-1.6,1.81s-1.6-.72-1.6-1.81V82.16c0-1.08.51-1.8,1.6-1.8S418.66,81.08,418.66,82.16Zm-2.4,0v3.63c0,.61.24,1,.8,1s.8-.42.8-1V82.11c0-.61-.24-1-.8-1S416.26,81.5,416.26,82.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.46,127.71c0,3.38-3.79,4.59-3.81,7.17v.18h3.68v1.14h-4.91v-1c0-3.61,3.79-4.32,3.79-7.47,0-1.16-.38-1.76-1.31-1.76s-1.31.65-1.31,1.65v1h-1.17v-.91c0-1.72.78-2.86,2.51-2.86S402.46,126,402.46,127.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.52,127.69c0-1.71.84-2.82,2.56-2.82s2.58,1.11,2.58,2.82v5.78c0,1.72-.85,2.84-2.58,2.84s-2.56-1.12-2.56-2.84Zm1.23,5.86c0,1,.43,1.62,1.33,1.62s1.33-.61,1.33-1.62v-5.92c0-1-.42-1.63-1.33-1.63s-1.33.6-1.33,1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,126.73v3.54c0,1.09-.51,1.81-1.6,1.81s-1.6-.72-1.6-1.81v-3.54c0-1.07.51-1.81,1.6-1.81S413,125.66,413,126.73Zm-2.4,0v3.66c0,.6.22,1,.8,1s.8-.4.8-1v-3.66c0-.6-.24-1-.8-1S410.58,126.08,410.58,126.68Zm6.1-1.69-4.42,11.21h-.76L415.92,125Zm1.81,5.92v3.52c0,1.09-.5,1.81-1.6,1.81s-1.61-.72-1.61-1.81v-3.52c0-1.07.52-1.79,1.61-1.79S418.49,129.84,418.49,130.91Zm-2.41,0v3.64c0,.61.25,1,.81,1s.8-.41.8-1v-3.64c0-.6-.25-1-.8-1S416.08,130.26,416.08,130.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.96,
    y: 173.35,
    width: 7.25,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.73,
    y1: 176.98,
    x2: 257.17,
    y2: 176.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.96,
    y: 186.49,
    width: 7.25,
    height: 7.25,
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.73,
    y1: 190.11,
    x2: 257.17,
    y2: 190.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.96,
    y: 199.62,
    width: 7.25,
    height: 7.25,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.73,
    y1: 203.24,
    x2: 257.17,
    y2: 203.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,211.64a25.82,25.82,0,0,0,10-40",
    style: {
      fill: "none",
      stroke: "#10A7D0",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,202a25.83,25.83,0,0,0,31.66,9.67",
    style: {
      fill: "none",
      stroke: "#7d7d7d",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,171.61A25.82,25.82,0,0,0,153.9,202",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.6,
    y1: 185.04,
    x2: 187.2,
    y2: 185.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.6,
    y1: 191.71,
    x2: 187.2,
    y2: 191.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 182.81,
    x2: 420.34,
    y2: 182.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 186.22,
    x2: 420.34,
    y2: 186.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,166.9A16,16,0,0,0,389,176.3h32A15.31,15.31,0,0,0,417.94,166.9Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,176.3l12.93-9.4a15.31,15.31,0,0,1,3.05,9.4Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,176.3,410,161.1a15.3,15.3,0,0,1,8,5.8Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,176.3l-4.94-15.2a15.33,15.33,0,0,1,9.88,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,176.3l-12.93-9.4a15.3,15.3,0,0,1,8-5.8Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,176.3H389a15.32,15.32,0,0,1,3.06-9.4Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,176.3a1.94,1.94,0,1,0-1.93,1.93A1.92,1.92,0,0,0,406.94,176.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.01,
    y1: 176.3,
    x2: 411.58,
    y2: 166.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 214.81,
    x2: 420.34,
    y2: 214.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 218.22,
    x2: 420.34,
    y2: 218.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,198.91A16,16,0,0,0,389,208.3h32A15.26,15.26,0,0,0,417.94,198.91Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,208.3l12.93-9.39A15.26,15.26,0,0,1,421,208.3Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,208.3,410,193.1a15.26,15.26,0,0,1,8,5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,208.3l-4.94-15.2a15.33,15.33,0,0,1,9.88,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,208.3l-12.93-9.39a15.26,15.26,0,0,1,8-5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,208.3H389a15.27,15.27,0,0,1,3.06-9.39Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,208.3a1.94,1.94,0,1,0-1.93,1.94A1.92,1.92,0,0,0,406.94,208.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.01,
    y1: 208.3,
    x2: 398.58,
    y2: 199.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.39,
    y1: 246.81,
    x2: 389.67,
    y2: 246.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.39,
    y1: 250.22,
    x2: 389.67,
    y2: 250.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,230.91A16,16,0,0,1,421,240.3H389A15.29,15.29,0,0,1,392.08,230.91Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.3l-12.93-9.39A15.29,15.29,0,0,0,389,240.3Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.3l-4.94-15.2a15.26,15.26,0,0,0-8,5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.3,410,225.1a15.33,15.33,0,0,0-9.88,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.3l12.93-9.39a15.26,15.26,0,0,0-8-5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.3h16a15.28,15.28,0,0,0-3.05-9.39Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.07,240.3a1.94,1.94,0,1,1,1.94,1.94A1.94,1.94,0,0,1,403.07,240.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.01,
    y1: 240.3,
    x2: 393.25,
    y2: 235.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 278.81,
    x2: 420.34,
    y2: 278.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.63,
    y1: 282.22,
    x2: 420.34,
    y2: 282.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,262.91a16,16,0,0,0-28.92,9.4h32A15.31,15.31,0,0,0,417.94,262.91Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.31l12.93-9.4a15.31,15.31,0,0,1,3.05,9.4Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.31,410,257.1a15.32,15.32,0,0,1,8,5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.31l-4.94-15.21a15.33,15.33,0,0,1,9.88,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.31l-12.93-9.4a15.32,15.32,0,0,1,8-5.81Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,272.31H389a15.32,15.32,0,0,1,3.06-9.4Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,272.31a1.94,1.94,0,1,0-1.93,1.93A1.93,1.93,0,0,0,406.94,272.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.01,
    y1: 272.31,
    x2: 390.46,
    y2: 272.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.81,50.86c1.3.18,1.9,1.19,1.9,2.63v.29h-1.12v-.37c0-.95-.38-1.53-1.24-1.53s-1.22.58-1.22,1.53c0,2.4,3.59,2.41,3.59,5.43,0,1.43-.61,2.46-1.91,2.64v.81h-1v-.81c-1.33-.18-1.92-1.19-1.92-2.64v-.66H351v.73c0,1,.4,1.51,1.26,1.51s1.25-.55,1.25-1.51c0-2.38-3.58-2.41-3.58-5.42,0-1.47.6-2.43,1.88-2.63V50h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.64,53.39v.28a2.13,2.13,0,0,1-1.3,2.2,2.14,2.14,0,0,1,1.3,2.22v.82c0,1.64-.77,2.71-2.42,2.71s-2.4-1.07-2.4-2.71v-.73h1.12V59c0,1,.4,1.54,1.25,1.54s1.26-.56,1.26-1.65v-.82c0-1.06-.45-1.56-1.35-1.59h-.64V55.4h.7a1.29,1.29,0,0,0,1.29-1.47v-.49c0-1.1-.39-1.67-1.26-1.67s-1.25.6-1.25,1.56v.55h-1.12v-.49c0-1.63.77-2.69,2.4-2.69S360.64,51.76,360.64,53.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.62,53.41c0,3.22-3.63,4.39-3.64,6.85v.16h3.51v1.09H361.8v-.92c0-3.45,3.62-4.12,3.62-7.13,0-1.11-.36-1.69-1.25-1.69s-1.25.63-1.25,1.58v.95H361.8v-.88c0-1.63.75-2.72,2.4-2.72S366.62,51.77,366.62,53.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24,61.51h-.44V60h1.14V61.4l-.59,1.45h-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.36,55.17a1.72,1.72,0,0,1,1.59-.89c1.37,0,2,1,2,2.54v2.09c0,1.64-.77,2.71-2.41,2.71s-2.4-1.07-2.4-2.71v-.72h1.12V59c0,1,.39,1.54,1.25,1.54s1.25-.58,1.25-1.54V56.91c0-1-.39-1.54-1.25-1.54a1.15,1.15,0,0,0-1.21,1.14v.25h-1.11l.29-5.95h4.21v1.07h-3.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88,53.38v.2h-1.11V53.3c0-1-.4-1.53-1.27-1.53s-1.3.58-1.3,1.73v2.4a1.73,1.73,0,0,1,1.73-1.15c1.37,0,2,1,2,2.54v1.62c0,1.64-.81,2.71-2.44,2.71S376,60.55,376,58.91V53.46c0-1.7.76-2.76,2.46-2.76S380.88,51.74,380.88,53.38Zm-3.68,4V59c0,1,.4,1.54,1.27,1.54s1.27-.58,1.27-1.54V57.38c0-1-.42-1.54-1.27-1.54S377.2,56.42,377.2,57.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83,53.39v5.46c0,1.7-.76,2.77-2.48,2.77s-2.41-1.06-2.41-2.69v-.2h1.12V59c0,1,.41,1.53,1.26,1.53s1.32-.58,1.32-1.71v-2.4a1.71,1.71,0,0,1-1.73,1.13c-1.37,0-2-1-2-2.52V53.39c0-1.63.8-2.69,2.45-2.69S386.83,51.76,386.83,53.39Zm-3.73-.06v1.61c0,1,.41,1.54,1.27,1.54s1.27-.58,1.27-1.54V53.33c0-1-.4-1.54-1.27-1.54S383.1,52.35,383.1,53.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.5,61.51h-.44V60h1.14V61.4l-.59,1.45h-.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.33,53.35v.33a2.12,2.12,0,0,1-1.22,2.21,2.17,2.17,0,0,1,1.22,2.26v.79a2.52,2.52,0,1,1-5,0v-.79a2.14,2.14,0,0,1,1.24-2.26,2.09,2.09,0,0,1-1.24-2.21v-.33a2.52,2.52,0,1,1,5,0Zm-3.87,0v.52c0,1,.51,1.5,1.35,1.5s1.34-.46,1.34-1.5v-.52c0-1.1-.5-1.61-1.34-1.61S391.46,52.28,391.46,53.38Zm0,4.63v.9c0,1.1.49,1.62,1.35,1.62s1.33-.52,1.34-1.62V58c0-1-.45-1.54-1.34-1.54S391.46,57,391.46,58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.22,53.39v5.46c0,1.7-.77,2.77-2.48,2.77s-2.41-1.06-2.41-2.69v-.2h1.11V59c0,1,.41,1.53,1.27,1.53S400,60,400,58.82v-2.4a1.73,1.73,0,0,1-1.73,1.13c-1.38,0-2-1-2-2.52V53.39c0-1.63.8-2.69,2.45-2.69S401.22,51.76,401.22,53.39Zm-3.73-.06v1.61c0,1,.41,1.54,1.27,1.54S400,55.9,400,54.94V53.33c0-1-.4-1.54-1.27-1.54S397.49,52.35,397.49,53.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.12,53.39v.28a2.12,2.12,0,0,1-1.3,2.2,2.14,2.14,0,0,1,1.3,2.22v.82c0,1.64-.76,2.71-2.42,2.71s-2.4-1.07-2.4-2.71v-.73h1.12V59c0,1,.4,1.54,1.25,1.54s1.26-.56,1.26-1.65v-.82c0-1.06-.45-1.56-1.35-1.59h-.64V55.4h.7a1.29,1.29,0,0,0,1.29-1.47v-.49c0-1.1-.38-1.67-1.26-1.67s-1.25.6-1.25,1.56v.55H402.3v-.49c0-1.63.77-2.69,2.4-2.69S407.12,51.76,407.12,53.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.43,60v1.48h-1.15V60Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.56,53.39c0-1.63.81-2.69,2.45-2.69s2.46,1.06,2.46,2.69v5.52c0,1.64-.81,2.71-2.46,2.71s-2.45-1.07-2.45-2.71Zm1.18,5.6c0,1,.41,1.54,1.27,1.54s1.27-.58,1.27-1.54V53.33c0-1-.4-1.56-1.27-1.56s-1.27.58-1.27,1.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.35,53.39v.28a2.13,2.13,0,0,1-1.29,2.2,2.13,2.13,0,0,1,1.29,2.22v.82c0,1.64-.76,2.71-2.41,2.71s-2.4-1.07-2.4-2.71v-.73h1.12V59c0,1,.39,1.54,1.25,1.54s1.25-.56,1.25-1.65v-.82c0-1.06-.44-1.56-1.34-1.59h-.64V55.4h.7a1.29,1.29,0,0,0,1.28-1.47v-.49c0-1.1-.38-1.67-1.25-1.67s-1.25.6-1.25,1.56v.55h-1.12v-.49c0-1.63.76-2.69,2.4-2.69S421.35,51.76,421.35,53.39Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.77,230.52a22.24,22.24,0,0,0-3,4.56c-.66,1.74-1.09,4.13-2,5.43s-3.91.87-3.91,2.83a9.7,9.7,0,0,0,1.3,4.13s.66,6.3,1.52,7.82,10,0,10,0,3.48-5.22,3.48-10.65S423.24,231,419.77,230.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,240.47c-.09.77-.4,1.37-.7,1.34s-.47-.69-.38-1.47.4-1.37.69-1.34S418.11,239.69,418,240.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,236.6S420,236,420,239",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.19,380l-.87,18s5.87,10.65,6.09,20.64,4.78,33.46,4.78,33.46l.87,13.48-2.18.21-1.74-3.47s-.86,3.69-1.52,3.69-5.86-.43-6.08-2-.65-2.39.65-2.6,5-8.91,5-8.91-9.13-21.08-10.86-25.2a99.83,99.83,0,0,1-3.48-10.87s-1.3-7.17-2.83-14.55-2.82-20.86-2.82-20.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.19,452.57c-1.09,3.26-2.83,8.26-2.83,8.26l-2.17.65c-1.3.21-.87,1.08-.65,2.6s5.43,2,6.08,2,1.52-3.69,1.52-3.69l1.74,3.47,2.18-.21-.87-13.48S446.28,449.31,445.19,452.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.51,378.48s.22,5.87,1.74,8.69,3,12.6,3,12.6-.22,15.43,2.17,23,5.65,32.38,5.65,32.38-6.51,7.82-7.38,8.69-5.87,3-4.78,3.91,7.17,1.52,9.12,1.3,8.26-4.78,8.91-5.21.87,5.65.87,5.65h2.61l.65-9.13s.43-3.26-.22-4.78a26.71,26.71,0,0,0-2.17-3.69l1.08-27.16s1.74-9.13.44-15.21-3-15.86-3-15.86l.87-13,.65-8.47s-2.61-2-9.13-2a80.94,80.94,0,0,0-12.6,1.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.11,460.39s.43-3.26-.22-4.78a21.24,21.24,0,0,0-1.65-2.91,18.56,18.56,0,0,0-4.22,3.56c-1.73,2.18-5.43,6.74-7.38,7.82-1.43.8-4,.78-5.3.71-1.72,1-4.19,2.35-3.39,3,1.08.87,7.17,1.52,9.12,1.3s8.26-4.78,8.91-5.21.87,5.65.87,5.65h2.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,331.77s-1.08,16.94-.86,25.63,1.3,22.82,1.3,22.82,3.91,1.3,6.3,1.95a15,15,0,0,0,3.48.66l2.82-5,2,5.43s4.56.43,10.43.43,11.29-2.6,11.73-3.25a15.11,15.11,0,0,1,1.52-1.74l-2-20.64s3.91-10.22,4.13-15.43S445,331.12,445,331.12s-10.21,3.25-18.47,1.73-19.77-4.12-19.77-4.12Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,295.27s4.12,18,3.91,20.64-5,10.64-5,10.64-5.21-9.56-6.08-15,0-9.56,1.08-11.51,4.13-7,4.13-7Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,275.93s-8,13.9-8,17.6.22,18.25-1.09,22.59-3,16.73-3,16.73,3,4.13,14.13,5.65,24.55-3.26,25.85-3.69a33.26,33.26,0,0,0,3.69-1.74l1.31-.43s-4.13-7.39-5.87-10.87-5.21-9.12-4.34-13.9,5.86-12.39,8-19.34,1.3-15.86-2-20.21-16.08-4.34-21.73-1.08A15.08,15.08,0,0,0,415.64,275.93Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.08,220.35c-3.46,1.5-6.18,4.21-5.27,8,1.52,6.3,6.09,10.43,6.09,15.86s-2.61,16.08-6.3,20.2-6.74,17.39-3.48,17.82,2.17-5,6.73-9.13,10.65-.86,12.17,5.22-1.08,11.51,2.17,15.42,10.87,2.39,13.69-2.39.44-8.9,2.18-10.86,5.64-5.21,4.34-10.21-9.56-5.87-8.69-12.6,5.87-15.65,3.69-21.08-6.3-11.73-9.77-14.12a22.86,22.86,0,0,0-9.9-3.4A15.67,15.67,0,0,0,423.08,220.35Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.69,339.59s-4.13,8.47-4.35,9.78-.43,10.86-.43,10.86,1.08,3.26,1.74,3.69,1.52-.21,1.52-1.74V360s1.3-2.82,2.39-5,.65-7.6.65-7.6l3.47-5.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.95 342.41 412.38 346.11 414.55 341.54 408.69 339.59 406.95 342.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.37,281.14s-3.26-9.77-9.34-9.34-7.61,14.12-7.61,19.77.87,26.94.87,26.94l-8.69,21.08,6.3,3.91s14.56-21.73,15-22.81,1.74-29.55,1.74-29.55",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.83,239.92s2.82-.21,1.95,2.17-2.38,3.9-3.46,4.12a10.22,10.22,0,0,1-1.74.21Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.43,238.84s-2.6.43-2.16,2.38,2,5.2,2.81,5.42,2.17-1.08,2.17-1.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.76,298s3-7.6,4.56-9.12,3.91-7,3.91-7l2.18,7-10,11.08S292.54,300.17,292.76,298Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.3,267.63l5.41,22a2.28,2.28,0,0,0,2.91,1.64l13.15-4.12a2.3,2.3,0,0,0,1.55-2.74L313,263a2.31,2.31,0,0,0-2.83-1.67l-13.27,3.58A2.31,2.31,0,0,0,295.3,267.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.9 247.29 332.68 258.34 348.07 259.86 347.63 249.02 332.9 247.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,218.47s-6.06,4.33-7.36,8.88.86,10.62,1.73,12.36,3.68,9.31,4.77,10.61,6.06,3.47,7.8,3,7.15-1.09,7.8-3.25,4.11-10.4,4.55-11.7,1.73-10.62.43-12.57a64.08,64.08,0,0,0-5.42-6.07,10,10,0,0,0-6.06-3.9C338.75,215,334.63,218.47,334.63,218.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.4,260.51a10.14,10.14,0,0,1,8.67-4.55c6.06,0,11.91.21,13.43.65s4.33,5.85,4.33,5.85-15.6-1.09-19.93-1.09a61.65,61.65,0,0,0-8.45.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.9,248.81a42,42,0,0,1-3.68-4.77,3.13,3.13,0,0,1,.43-3.47,6,6,0,0,1,1.73-.65s.65-6.07.44-6.93.65-1.09,1.73-.87,1.52,5.2,1.52,5.2a7.33,7.33,0,0,1,2.81,1.74c1.3,1.3,1.52,4.11,1.52,5v3.47l.43,3-6.06,1.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,267.22s-1.3-15.38-1.3-16.25,1.74-2.38,3.47-2.38,3.47,1.73,3.47,1.73,6.28,18.42,7.58,20.15,3.9,8.89,3.9,11-7.8-.21-10-2.16-6.5-10-6.5-10Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.44,326.68l-1.95,21.51s-2,50.19-2,53.67.65,28.46,1.52,35,.65,18.25.65,18.25-2.6,1.3-2.6,2.6v2.39a33.71,33.71,0,0,0-4.35,3.05c-1.08,1.08-2.39,3.47-.87,4.78s12.39,5.65,13.91,5.65,5.43-.66,6.3-2.18.22-8.47.22-8.47,1.95-3,1.95-4.13-.22-2.61-.22-4.34.87-21.95.87-21.95,3-42.37,3.48-43,2.39-30.2,2.39-30.2l3.69.44,5,36.28s6.74,33.89,6.95,35,3.48,19.12,3.48,19.12v5.65c0,1.74,2.17,5.21,2.17,5.21s-.43,5.44.65,7.39,5.44,2.17,8.7,1.09,2.6-5.43,2.6-7.61-.21-4.34-.21-4.34a40.71,40.71,0,0,1,0-5.43c.21-2.18-1.74-8.48-1.74-9.56s.65-27.38.21-33S363.16,386,363.16,386,361,352.54,361,351.67s.09-24,.09-24-8.78,2.26-23.55.74-21.29-2.83-21.29-2.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.45,262s-15.6,6.29-14.95,7.15-7.37,16-8,16.9-8.45,10.84-9.32,12.79-2.6,4.55.22,7.58,4.12,4.12,8,3.47S314.26,298,314.26,298s.44,14.09.65,17.77.22,4.77.22,6.72-1.08,3,1.52,5.41,13.65,5.42,21.45,5,14.08-.44,17.12-1.3,5.41-1.3,5.85-3.9a117,117,0,0,0,.65-11.92c0-2.17,1.3-24.7,1.3-24.7s6.93.65,10.18,0,5.42-6.72,4.55-9.54-4.33-5-6.07-6.71-2.81-4.12-5.2-6.72-3.46-2.6-5.41-3-8.24-2.6-8.24-2.6S337.23,260.51,324.45,262Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.78,325.87a89.53,89.53,0,0,0,9.62-8.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.1,329.58l1.73-1.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.67,
    y1: 326.47,
    x2: 349.64,
    y2: 322.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.26,
    y1: 297.99,
    x2: 310.58,
    y2: 276.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.11,
    y1: 279.57,
    x2: 312.53,
    y2: 287.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.62,264.62a61.48,61.48,0,0,1,11.91,19.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.85,271.56s4.77,8.45,6.07,11.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75,267.66s1.52,6.93,1.73,7.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.92,281.52c-.44,2.17-3.9,9.54-3.9,9.54s5.41-6.29,5.85-6.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg13);
export default __webpack_public_path__ + "static/media/img13.f01daf696c077356265b10ad1f4f88f6.svg";
export { ForwardRef as ReactComponent };